export default [
  {
    name: 'project_amount_collected_statistic',
    component_path: 'modules/templates/blocks/project/ProjectStatistic',
    settings: {
      statistic: 'amount_collected',
      text: 'amount'
    }
  }
]